import {Injectable} from "@angular/core";
import {ApiService} from "../../shared/api.service";
import {Headers} from "@angular/http";
import {User} from "../+users/user.model";

@Injectable()
export class UserService {

  private usersUrl = '/api/administration/users';

  private headers = new Headers({ 'Cache-Control': 'no-cache' });

  constructor(private apiService: ApiService){

  }

  getUsers(){
    return this.apiService.get(this.usersUrl, { headers : this.headers })
      .map(res => res as User[]);
  }

  getUserById(id: string){
    let url = `${this.usersUrl}/${id}`;

    return this.apiService.get(url, { headers : this.headers })
      .map(res => res as User);
  }

  createUser(user: User){
    return this.apiService.post(this.usersUrl,JSON.stringify(user))
      .map(res => res as User);
  }

  updateUser(user: User){
    let url = `${this.usersUrl}/${user['_id']}`;

    return this.apiService.put(url,JSON.stringify(user))
      .map(res => res as User);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+admin-app/shared/user.service.ts